/**
 * @generated SignedSource<<e2a0b97fea6f32b875e10364f5c5ba92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignStakeholderCategoryPathInputObject = {
  path: string;
  perspectiveId?: string | null | undefined;
  stakeholderId: string;
};
export type categoryCell_AssignStakeholderCategoryPathMutation$variables = {
  input: AssignStakeholderCategoryPathInputObject;
};
export type categoryCell_AssignStakeholderCategoryPathMutation$data = {
  readonly assignStakeholderCategoryPath: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categoryCell_AssignStakeholderCategoryPathMutation = {
  response: categoryCell_AssignStakeholderCategoryPathMutation$data;
  variables: categoryCell_AssignStakeholderCategoryPathMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categoryCell_AssignStakeholderCategoryPathMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryPathMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategoryPath",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categoryCell_AssignStakeholderCategoryPathMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryPathMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategoryPath",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a6bc4a27c127707c4e944c83657bb9d",
    "id": null,
    "metadata": {},
    "name": "categoryCell_AssignStakeholderCategoryPathMutation",
    "operationKind": "mutation",
    "text": "mutation categoryCell_AssignStakeholderCategoryPathMutation(\n  $input: AssignStakeholderCategoryPathInputObject!\n) {\n  assignStakeholderCategoryPath(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbe4318e3220d2352c374417a033d8f3";

export default node;
